import { useState } from 'react';

const useReusePoll = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClickReusePoll = () => {
    setIsOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsOpen(false);
  };

  return { isOpen, handleClickReusePoll, handleCloseDrawer };
};

export default useReusePoll;
